import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var funnel_default = /* @__PURE__ */ jsx(SVG, { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx(Path, { d: "M10 17.5H14V16H10V17.5ZM6 6V7.5H18V6H6ZM8 12.5H16V11H8V12.5Z" }) });
export {
  funnel_default as default
};
//# sourceMappingURL=funnel.js.map
